
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { FileQuestion, Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full mx-auto text-center space-y-6">
        <div className="flex justify-center mb-6">
          <FileQuestion className="h-24 w-24 text-muted-foreground animate-floating" />
        </div>
        
        <h1 className="text-4xl font-bold">Sayfa Bulunamadı</h1>
        
        <div className="space-y-2">
          <p className="text-xl text-muted-foreground">
            Aradığınız sayfaya ulaşılamıyor.
          </p>
          <p className="text-sm text-muted-foreground">
            Bu URL: <span className="font-mono bg-muted px-1 py-0.5 rounded">{location.pathname}</span>
          </p>
        </div>
        
        <div className="pt-4">
          <Button asChild className="gap-2">
            <Link to="/">
              <Home className="h-4 w-4" />
              Ana Sayfaya Dön
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
